// material-ui
import { Box, Stack, Typography } from '@mui/material';

// assets
import LogoImg from 'assets/images/logo.png';

// ==============================|| LOGO MAIN ||============================== //

export default function LogoMain() {
  return (
    <Stack
      direction="column"
      spacing={0.5}
      alignItems="center"
    >
      <Box
        component="img"
        src={LogoImg}
        alt="Verification Professional"
        sx={{
          height: 40,          // adjust 32–48 as needed
          width: 'auto',
          display: 'block'
        }}
      />
      <Typography
        variant="subtitle1"
        fontWeight={800}
        sx={{
          color: '#0b3d2e',    // dark green
          lineHeight: 1.1,
          letterSpacing: 0.4,
          textAlign: 'center'
        }}
      >
        Verification Professional
      </Typography>
    </Stack>
  );
}
